"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClassSerializer = void 0;
var models_1 = require("../../models");
/**
 * Serializes classes
 *
 * @author javier.perez
 */
var ClassSerializer = /** @class */ (function () {
    function ClassSerializer(userSerializer) {
        this.userSerializer = userSerializer;
    }
    ClassSerializer.prototype.serialize = function (_a) {
        var _this = this;
        var id = _a.id, name = _a.name, owner = _a.owner, teachers = _a.teachers, school = _a.school, totalStudents = _a.totalStudents, primaryTeacher = _a.primaryTeacher;
        return new models_1.Class({
            id: id,
            name: name,
            owner: owner ? this.userSerializer.serialize(owner) : undefined,
            school: school,
            totalStudents: totalStudents,
            teachers: teachers
                ? teachers.map(function (teacher) { return _this.userSerializer.serialize(teacher); })
                : undefined,
            primaryTeacher: primaryTeacher ? this.userSerializer.serialize(primaryTeacher) : undefined,
        });
    };
    return ClassSerializer;
}());
exports.ClassSerializer = ClassSerializer;
